import { genView } from "./colleges.ts";

export default genView("countries", "country");
